import type { Coverage } from '~/layers/forms/models/coverage'
import { AuxiliarMeta } from '~/layers/forms/models/globals/auxiliarMeta'

export type Travel = Nullable<{
  argentoInsuranceDestinationId: string
  destination: AuxiliarMeta
  from: Date
  to: Date
  reason: PropsTypesOf<typeof TravelReasonEnum>['code']
  calculatedDays: number
}>

function load(model?: Partial<Travel> | null): Travel {
  return {
    argentoInsuranceDestinationId: model?.argentoInsuranceDestinationId ?? null,
    destination: model?.destination ?? AuxiliarMeta.load(),
    from: model?.from ?? null,
    to: model?.to ?? null,
    reason: model?.reason ?? null,
    calculatedDays: model?.calculatedDays ?? null,
  }
}

export const TravelReasonEnum = {
  Studies: { label: 'Estudios', code: 'Studies' },
  Business: { label: 'Negocios', code: 'Business' },
  Pleasure: { label: 'Placer', code: 'Pleasure' },
} as const

export const TravelTypeEnum = {
  Tourist: { label: 'Turismo', value: 'tourist' },
  Schengen: { label: 'Schengen', value: 'schengen' },
} as const

function getTravelReasonTypeList() {
  return Object.values(TravelReasonEnum)
}

function getTravelTypeList() {
  return Object.values(TravelTypeEnum)
}

const map = {
  toViajeViewModel({
    model,
    coverage,
  }: {
    model: Travel
    coverage?: Coverage
  }): SiteApiSchema<'ViajeViewModel'> {
    const { argentoInsurancePlanId } = coverage ?? {}

    return {
      destinoId: model.destination?.id,
      destino: model.destination?.name,
      duracion: model.calculatedDays ?? undefined,
      fechaSalida: model.from ? model.from.toJSON() : undefined,
      fechaRetorno: model.to ? model.to.toJSON() : undefined,
      motivo: model.reason ? TravelReasonEnum[model.reason].label : undefined,
      productoId: argentoInsurancePlanId ? argentoInsurancePlanId : undefined,
      productoNombre: coverage?.planName,
    }
  },
}

export const Travel = {
  load,
  getTravelReasonTypeList,
  getTravelTypeList,
  map,
}
